import { create } from 'zustand';
import { BudgetCurrency } from './api/budget-currency';
import { BudgetLocale } from './api/budget-locale';
// Default empty BudgetSummary
const defaultBudgetSummary = {
    summaryByMonth: new Map(),
    initialTransactionDate: '',
    initialMonth: 0,
    initialYear: 0,
    accountSummary: {
        accountBalanceById: new Map(),
        reconciledBalanceById: new Map(),
        clearedBalanceById: new Map(),
        unclearedBalanceById: new Map(),
        clearedBalanceCountById: new Map(),
        unclearedBalanceCountById: new Map(),
        uncategorizedBalanceById: new Map(),
        creditCardBalance: 0,
        nonCreditCardBalance: 0,
        liquidBudget: 0,
        liquidNetWorth: 0,
        offBudgetAssetBalance: 0,
        offBudgetLiabilityBalance: 0,
        offBudgetNetWorth: 0,
    },
};
// create the store
export const useBudgetStore = create((set) => ({
    budgetId: '',
    setBudgetId: (budgetId) => set({ budgetId }),
    budgetSummary: defaultBudgetSummary,
    setBudgetSummary: (budgetSummary) => set({ budgetSummary }),
    currency: BudgetCurrency.USD,
    setCurrency: (currency) => set({ currency }),
    locale: BudgetLocale.EN_US,
    setLocale: (locale) => set({ locale }),
}));
// budget id
export const useBudgetId = () => useBudgetStore((state) => state.budgetId);
export const useSetBudgetId = () => useBudgetStore((state) => state.setBudgetId);
// budget summary
export const useBudgetSummary = () => useBudgetStore((state) => state.budgetSummary);
export const useSetBudgetSummary = () => useBudgetStore((state) => state.setBudgetSummary);
// currency
export const useBudgetCurrency = () => useBudgetStore((state) => state.currency);
export const useSetBudgetCurrency = () => useBudgetStore((state) => state.setCurrency);
// locale
export const useBudgetLocale = () => useBudgetStore((state) => state.locale);
export const useSetBudgetLocale = () => useBudgetStore((state) => state.setLocale);
